import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../../../helpers/api';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { keyByProperty } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';

function* loadAccreditation({ payload }) {
  try {
    const { accreditationId, clientId, clientType } = payload;
    const api = new Api(`${clientType}/:clientId/accreditations/:accreditationId`);
    const formDataApi = new Api(`${clientType}/:clientId/accreditations/form_data`);

    const { accreditation, formInfo } = yield all({
      accreditation: call(
        sendRequest,
        api.multipleParamsGetRequest,
        { accreditationId, clientId },
        notifications.REQUEST_ERROR,
      ),
      formInfo: call(sendRequest, formDataApi.multipleParamsGetRequest, { clientId }, notifications.REQUEST_ERROR),
    });

    if (accreditation?.data?.success?.data && formInfo?.data?.success?.data) {
      yield put(
        actions.loadAccreditationSuccess({
          accreditation: accreditation.data.success.data,
          formInfo: formInfo.data.success.data,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateAccreditation({ payload }) {
  try {
    const { editForm, clientId, clientType, accreditationId } = payload;
    const api = new Api(`${clientType}/:clientId/accreditations/:accreditationId`);

    const propsArray = Object.values(editForm);
    const editFormData = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      api.multiparamsUpdateItem,
      {
        data: {
          accreditation_requirement: {
            accreditation_id: editFormData.accreditation.id,
            position_ids: editFormData.positions.map(position => position.id),
          },
        },
        params: {
          clientId,
          accreditationId,
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        yield put(push(`/${clientType}/${clientId}?tab=accreditation`));

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.updated_successfully', {
              item: t('dash.clients.components.accreditations.accreditation_label'),
            }),
          }),
        );
      } else {
        yield put(actions.updateAccreditationError(result));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadAccreditation, updateAccreditation };

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_DATA_REQUEST, loadAccreditation),
    takeEvery(actions.UPDATE_DATA_REQUEST, updateAccreditation),
  ]);
}
